import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind classes with conflict resolution — the shadcn/ui
 * convention. `cn('p-2', condition && 'p-4')` yields `p-4`, so component
 * variants can be overridden at the call site without `!important`.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
